import AppConstants from '../constants/app.constants'
import router from '../router'
import RouterUtils from './router.util'

const TASK_ROUTER_NAME = AppConstants.TASK_STATEMENT_ROUTER_NAME
const SORT_KEY = 'sort'
export default class BatchTaskUtils {
  /**
   * ページに切り替え タスクの詳細
   * @param {*} queryObj オブジェクト クエリ
   */
  static goToTaskDetailPage = (queryObj) => {
    if (!queryObj) {
      return
    }
    let taskQueryString = `?batchNo=${RouterUtils.encodedUrlParam(queryObj.batchNo)}&batchDetailNo=${queryObj.batchDetailNo}&showBatchDetails=${queryObj.showBatchDetails}`
    const sortParam = BatchTaskUtils.getCurrentTaskDetailSortParamInStorage()
    if (sortParam) {
      taskQueryString += `&${sortParam}`
    }
    // ストア内のタスクの初期化クエリ文字列
    BatchTaskUtils.updateStorageTaskStatement(taskQueryString)
    router.push({ name: TASK_ROUTER_NAME, query: queryObj }).catch(error => {
      RouterUtils._ignoreNavDuplicated(error)
    })
  }
  /**
   * ストア内のタスクの初期化クエリ文字列
   */
  static updateStorageTaskStatement = (taskQueryString) => {
    RouterUtils.updateQueryObjectToStorage(TASK_ROUTER_NAME, taskQueryString)
  }

  /**
   * タスク明細のソートパラメータをローカルストレージから取得する
   * @returns 並べ替えパラメータ
   */
  static getCurrentTaskDetailSortParamInStorage = () => {
    let sortParamStr = ''
    const queryObjTaskDetail = RouterUtils.getQueryObjectFromStorageByRouterName(TASK_ROUTER_NAME)

    if (queryObjTaskDetail.hasOwnProperty(SORT_KEY)) {
      sortParamStr = `${SORT_KEY}=${queryObjTaskDetail[SORT_KEY]}`
    }
    return sortParamStr
  }

  /**
   * バッチ文字列からバッチ番号とバッチ明細番号を取得する。
   * バッチ文字列は、ハイフンで区切られた batchNo と batchDetailNo で構成されます。
   * バッチ明細番号は最後のハイフンの後の数字です。
   * バッチ番号は最後のハイフンを除いた残りです。
   *
   * @param {*} batchStr 選択されたバッチ
   * @returns リストバッチ番号とバッチ明細番号
   */
  static getBatchNoAndBatchDetailNo = (batchStr) => {
    let batchObject = { batchNo: '', batchDetailNo: null }
    if (batchStr) {
      let regex = new RegExp(/(.*)-([^-]*)/, 'g')
      const batchStrItems = regex.exec(batchStr)
      if (batchStrItems && batchStrItems.length >= 2) {
        batchObject['batchNo'] = batchStrItems[1]
        batchObject['batchDetailNo'] = batchStrItems[2]
      }
    }
    return batchObject
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/batch-task.util.js